export function filtersRam (value) {
  return value / 1024
}
const digitsRE = /(\d{3})(?=\d)/g
export function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : ''
  decimals = decimals != null ? decimals : 0
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1.') +
    _float
}

export function filtersTicketStatus (value) {
  let status = ''
  if (value === 'open') status = 'Chưa xử lý'
  else if (value === 'closed') status = 'Đã xử lý'
  return status
}

export function numberWithDelimiter (number, delimiter = '.') {
  return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
}

export function filterTimezone (value) {
  const utc = new Date().getTimezoneOffset() / -60
  const timezoneVN = (1000 * 60 * 60 * utc)
  const historyTime = Date.parse(value) + timezoneVN
  value = new Date(historyTime)
  return value
}
export function capitalize (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function parseHours () {
  var quarterHours = ['00', '30']
  var times = []
  for (var i = 0; i < 6; i++) {
    for (var j = 0; j < 2; j++) {
      times.push({value: '0' + i + ':' + quarterHours[j]})
    }
  }
  times.push({value: '06:00'})
  for (var k = 21; k < 24; k++) {
    for (var m = 0; m < 2; m++) {
      times.push({value: k + ':' + quarterHours[m]})
    }
  }
  return times
}



// WEBPACK FOOTER //
// ./src/filters/index.js